<template>
  <div class="col-12">
    <div class="card mb-5" style="margin-top: 4rem; overflow: visible">
      <div
        class="card-header p-0 position-relative mt-n4 mx-3 z-index-2"
        style="height: 60px;"
      >
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6
              class="text-white text-capitalize ps-3 pe-3 mb-0"
              style="font-size: 1rem"
            >
              {{ $t('guardians.title') }}
            </h6>
          </div>
        </div>
      </div>

      <div class="card-body px-0 pb-2 pe-3">
        <div class="card-body px-0 pb-2">
          <div v-if="!loading">
            <!-- Father Section -->
            <div v-if="guardians.father" class="p-4 border-bottom">
              <h6 class="text-primary mb-3">{{ $t('relations.father') }}</h6>
              <GuardianCard :guardian="guardians.father" />
            </div>

            <!-- Mother Section -->
            <div v-if="guardians.mother" class="p-4 border-bottom">
              <h6 class="text-primary mb-3">{{ $t('relations.mother') }}</h6>
              <GuardianCard :guardian="guardians.mother" />
            </div>

            <!-- Uncles Section -->
            <div v-if="guardians.uncles.length > 0" class="p-4 border-bottom">
              <h6 class="text-primary mb-3">{{ $t('relations.uncles') }}</h6>
              <div class="row">
                <div
                  v-for="uncle in guardians.uncles"
                  :key="uncle.id"
                  class="col-md-6"
                >
                  <GuardianCard :guardian="uncle" />
                </div>
              </div>
            </div>

            <!-- Aunts Section -->
            <div v-if="guardians.aunts.length > 0" class="p-4 border-bottom">
              <h6 class="text-primary mb-3">{{ $t('relations.aunts') }}</h6>
              <div class="row">
                <div
                  v-for="aunt in guardians.aunts"
                  :key="aunt.id"
                  class="col-md-6"
                >
                  <GuardianCard :guardian="aunt" />
                </div>
              </div>
            </div>

            <!-- Other Guardians Section -->
            <div v-if="guardians.other_guardians.length > 0" class="p-4">
              <h6 class="text-primary mb-3">{{ $t('relations.otherGuardians') }}</h6>
              <div class="row">
                <div
                  v-for="guardian in guardians.other_guardians"
                  :key="guardian.id"
                  class="col-md-6"
                >
                  <GuardianCard :guardian="guardian" />
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div
              v-if="
                !guardians.father &&
                !guardians.mother &&
                guardians.uncles.length === 0 &&
                guardians.aunts.length === 0 &&
                guardians.other_guardians.length === 0
              "
              class="p-4 text-center"
            >
              <i class="fas fa-users-slash fa-2x mb-2 text-muted"></i>
              <p class="text-muted">{{ $t('guardians.noGuardians') }}</p>
            </div>
          </div>

          <LoadingSpinner v-else :message="$t('guardians.loading')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import GuardianCard from "@/components/features/studentGuardians/GuardianCard.vue";
import api from "@/api";

const route = useRoute();
const toast = useToast();

const loading = ref(true);
const student = ref({});
const guardians = ref({
  father: null,
  mother: null,
  uncles: [],
  aunts: [],
  other_guardians: []
});

const fetchData = async () => {
  try {
    loading.value = true;
    const studentResponse = await api.get(`/students/${route.params.id}`);
    student.value = studentResponse.data.data || studentResponse.data;

    const guardiansResponse = await api.get(
      `/students/${route.params.id}/guardians`
    );
    guardians.value = guardiansResponse.data;
  } catch (error) {
    toast.error("فشل في تحميل البيانات"); // 🔴 You can also localize this if needed
    console.error("Error fetching data:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => fetchData());
</script>
